<div class="date-range-display" *ngIf="resolvedDateRange">
  <div class="date-range-container">
    <i class="fa fa-calendar" aria-hidden="true"></i>
    <span class="date-range-text">{{resolvedDateRange}}</span>
  </div>
</div>
